// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__25sp2","label":"CategoryService_label__1jdtf","location":"CategoryService_location__37k6d"};